module.exports = "https://static.wanderu.com/static/media/fast-buses.6dfeee83.png";